import React from "react";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import clsx from "clsx";
import Button from "@mui/material/Button";
import { Typography, Grid, Box } from "@mui/material";
import CustomTextField from "../../common/TextField";
import DraggableModal from "../../common/DraggableModal";
import DraggableModalHead from "../../common/DraggableModal/DraggableModalHead";
import DraggableModalBody from "../../common/DraggableModal/DraggableModalBody";

const useStyles = makeStyles(theme => ({
  modal: {
    width: "600px",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  modalFooter: {
    marginTop: 20,
    paddingTop: 10,
    borderTop: "1px solid #ddd",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  btnSave: {
    padding: "5px 15px",
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.common.blue,
    "&:hover": {
      backgroundColor: theme.palette.common.blue,
      opacity: 0.8,
    },
  },
  btnIcon: {
    fontSize: 14,
    marginRight: 8,
    verticalAlign: "middle",
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
  },
  text: {
    fontSize: 12,
    marginTop: 10,
  },
}));

const AddNewAddressModal = ({ open, handleClose }) => {
  const classes = useStyles();

  return (
    <DraggableModal
      open={open}
      handleClose={handleClose}
      customClass={classes.modal}
    >
      <DraggableModalHead handleClose={handleClose} title="Add new address" />
      <DraggableModalBody>
        <Grid container spacing={0} alignItems="center">
          <Grid item xs={12} md={3}>
            <Typography className={classes.label}>Company name</Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <CustomTextField />
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className={classes.label}>Receiver</Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <CustomTextField />
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className={classes.label}>Street Address</Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <CustomTextField />
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className={classes.label}>Address2</Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <CustomTextField />
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className={classes.label}>ZIP code</Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <CustomTextField />
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className={classes.label}>Place</Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <CustomTextField />
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className={classes.label}>Country</Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <CustomTextField />
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className={classes.label}>Shown as</Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <CustomTextField />
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className={classes.label}>E-mail</Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <CustomTextField />
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className={classes.label}>Phone</Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <CustomTextField />
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className={classes.label}>CustomerId</Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <CustomTextField />
          </Grid>
        </Grid>
        <Box className={classes.modalFooter} align="right">
          <Button className={classes.btnSave}>
            <Icon className={clsx(["fa fa-plus", classes.btnIcon])} />
            Add
          </Button>
        </Box>
      </DraggableModalBody>
    </DraggableModal>
  );
};

AddNewAddressModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AddNewAddressModal;
